import type { EventParams } from '@yandex-int/k-common';
import { WebinarEventBaseCert2025 as getWebinarEventBaseCert2025 } from './webinarEventBaseCert2025';

/** Серт для вебинара */
export const WebinarCert = (params: EventParams) => {
    const {
        school_name,
        locality,
        first_name,
        middle_name,
        last_name,
        event_duration,
        event_date,
        event_description,
        isNewCert2025,
    } = params;

    if (isNewCert2025) {
        return getWebinarEventBaseCert2025({ slug: 'webinar', ...params });
    }
    return `
        <!DOCTYPE html>
        <html lang="ru">
            <head>
                <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <link rel="stylesheet" href="https://e7n.s3.yandex.net/static/fonts/ys2/fonts.css" />
                <title>Сертификат за вебинар</title>
                <style>
                    @page {
                        size: 210mm 297mm;
                        margin: 0;
                    }

                    @media print {
                        html,
                        body {
                            color-adjust: exact;
                            print-color-adjust: exact;
                            -webkit-print-color-adjust: exact;
                        }
                    }

                    *,
                    *:before,
                    *:after {
                        box-sizing: border-box;
                        padding: 0;
                        margin: 0;
                    }

                    body {
                        color: #201e1e;

                        position: relative;

                        width: 210mm;
                        height: 297mm;

                        background: #ffffff;
                        box-sizing: border-box;
                        overflow: hidden;

                        page-break-after: always;
                        font-family: 'YS Text';
                        font-weight: 400;
                        font-style: normal;
                    }

                    .certificate__content {
                        padding: calc(34mm * 210 / 595);
                        height: 100%;
                        display: flex;
                        justify-content: space-between;
                    }

                    .certificate__background-image {
                        position: absolute;
                        top: 0;
                        right: 0;
                        height: 100%;
                        width: calc(234mm * 210 / 595);
                        background: linear-gradient(180deg, #baeeff 14.71%, rgba(186, 238, 255, 0) 30.29%),
                            linear-gradient(360deg, #baeeff 4.26%, rgba(186, 238, 255, 0) 30.52%);
                        z-index: -1;
                    }

                    .certificate__footer-image {
                        position: absolute;
                        bottom: 0;
                        right: 0;
                        width: calc(461mm * 210 / 595);
                    }

                    .certificate__column {
                        height: 100%;
                    }

                    .certificate__column_left {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        width: calc(327mm * 210 / 595);
                    }

                    .certificate__column_right {
                        display: flex;
                        flex-direction: column;
                        align-items: flex-end;
                        margin-left: 12mm;
                    }

                    .certificate__book-logo {
                        width: calc(199mm * 210 / 595);
                        height: calc(26mm * 210 / 595);

                        margin-bottom: calc(40mm * 210 / 595);
                    }

                    .certificate__header {
                        font-weight: 700;
                        font-size: calc(30mm * 210 / 595);
                        line-height: calc(36mm * 210 / 595);

                        text-transform: uppercase;

                        margin-bottom: calc(18mm * 210 / 595);
                    }

                    .certificate__school-data {
                        font-size: calc(14mm * 210 / 595);
                        line-height: calc(20mm * 210 / 595);

                        margin-bottom: calc(54mm * 210 / 595);
                    }

                    .certificate__teacher-data {
                        font-weight: 700;
                        font-size: calc(22mm * 210 / 595);
                        line-height: calc(30mm * 210 / 595);
                        text-transform: uppercase;
                        font-family: 'YS Display';

                        margin-bottom: calc(54mm * 210 / 595);
                    }

                    .certificate__description {
                        font-size: calc(16mm * 210 / 595);
                        line-height: calc(22mm * 210 / 595);
                    }

                    .signature__image {
                        height: calc(120mm * 210 / 595);

                        margin-bottom: calc(18mm * 210 / 595);
                    }

                    .signature__description {
                        font-size: calc(12mm * 210 / 595);
                        line-height: calc(17mm * 210 / 595);
                    }

                    .certificate__event-data {
                        font-size: calc(14mm * 210 / 595);
                        line-height: calc(20mm * 210 / 595);
                        text-align: end;
                        white-space: nowrap;

                        margin-bottom: calc(20mm * 210 / 595);
                    }

                    .certificate__additional-image {
                        width: calc(171mm * 210 / 595);
                        height: calc(291mm * 210 / 595);

                        margin-right: calc(9mm * 210 / 595);
                    }
                </style>
            </head>
            <body>
                <div class="certificate__content">
                    <div class="certificate__background-image"></div>
                    <img
                        src="https://e7n.s3.yandex.net/static/certificates/webinar/computer-2x.png"
                        alt="computer"
                        class="certificate__footer-image"
                    />

                    <div class="certificate__column certificate__column_left">
                        <div class="text-wrapper">
                            <img
                                src="https://e7n.s3.yandex.net/static/certificates/webinar/book-logo-elongated.svg"
                                alt="book-logo"
                                class="certificate__book-logo"
                            />

                            <div class="certificate__header">Сертификат</div>

                            <div class="certificate__school-data">
                                настоящий сертификат подтверждает, <br />что учитель ${school_name}, ${locality}
                            </div>

                            <div class="certificate__teacher-data">
                                ${last_name} <br />
                                ${first_name} <br />
                                ${middle_name}
                            </div>

                            <div class="certificate__description">${event_description}</div>
                        </div>

                        <div class="signature">
                            <img
                                src="https://e7n.s3.yandex.net/static/certificates-images/certificate_sing_da.png"
                                alt="signature"
                                class="signature__image"
                            />

                            <div class="signature__description">
                                Директор по взаимодействию<br />
                                с органами власти в сфере<br />
                                образования<br />
                                <br />
                                Д.А. Растворов
                            </div>
                        </div>
                    </div>

                    <div class="certificate__column certificate__column_right">
                        <div class="certificate__event-data">
                            г. Москва<br />
                            ${event_duration} ・ ${event_date}
                        </div>

                        <img
                            src="https://e7n.s3.yandex.net/static/certificates/webinar/paragraphs-2x.png"
                            alt="paragraphs"
                            class="certificate__additional-image"
                        />
                    </div>
                </div>
            </body>
        </html>
    `;
};
